"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _accountButton = _interopRequireDefault(require("./account-button"));
var _button = _interopRequireDefault(require("../../button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AuthenticatedUserButtons = function AuthenticatedUserButtons(_ref) {
  var accountButton = _ref.accountButton,
    accountNav = _ref.accountNav,
    layout = _ref.layout,
    signOutButton = _ref.signOutButton,
    useCrateLayout = _ref.useCrateLayout,
    useMaxWidthLayout = _ref.useMaxWidthLayout;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, signOutButton && !accountNav && /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    className: accountButton ? 'mr3' : '',
    color: "black"
  }, signOutButton)), (accountButton || accountNav) && /*#__PURE__*/_react["default"].createElement(_accountButton["default"], {
    accountButton: accountButton,
    accountNav: accountNav,
    layout: layout,
    signOutButton: signOutButton,
    useCrateLayout: useCrateLayout,
    useMaxWidthLayout: useMaxWidthLayout
  }));
};
AuthenticatedUserButtons.propTypes = process.env.NODE_ENV !== "production" ? {
  accountButton: _propTypes["default"].object,
  accountNav: _propTypes["default"].object,
  layout: _propTypes["default"].string,
  signOutButton: _propTypes["default"].object,
  useCrateLayout: _propTypes["default"].bool
} : {};
var _default = exports["default"] = AuthenticatedUserButtons;